import { FileOpen } from "@mui/icons-material";
import PropTypes from "prop-types";
import { useNavigate, useParams } from "react-router-dom";

import { GO_TO_CLIENT_DETAIL } from "../../../../../../../../../globalConstants";
import PermissionWrapper from "../../../../../../../global/PermissionWrapper";
import ActionButton from "../ui/ActionButton";

const OpenDocumentList = ({ permission }) => {
  const { id: caseId } = useParams();
  const navigate = useNavigate();
  return (
    <PermissionWrapper permission={permission}>
      <ActionButton
        title={"Open Document List"}
        icon={<FileOpen fontSize="18" />}
        action={() => {
          sessionStorage.removeItem(GO_TO_CLIENT_DETAIL);
          return navigate(`/client-detail/${caseId}/documents`, {
            state: { from: "client-detail" },
          });
        }}
      />
    </PermissionWrapper>
  );
};

export default OpenDocumentList;

OpenDocumentList.propTypes = {
  permission: PropTypes.any,
  setViewDocuments: PropTypes.func,
};
